// UI strings for the week's Duolingo line (course/DuolingoLine.tsx, docs/DUOLINGO.md "Decided
// 2026-10-06"): one quiet line on the week page once both of you have passed its lesson. Unit titles
// stay in English, as the Duolingo app shows them (course/duolingo.ts).
// Finnish follows docs/FINNISH-STYLE.md.
import { defineArea } from '../area';

export const duolingoFi = {
  line: (what: string) => `Duolingo tällä viikolla: ${what}`,
  /** One unit: "osio 1, yksikkö 5 (Learn lunar words)". */
  unit: (section: number, unit: number, title: string) => `osio ${section}, yksikkö ${unit} (${title})`,
  /** Two units of one section: "osio 1, yksiköt 7 ja 8 (Learn aquatic words, Learn terrestrial words)". */
  units: (section: number, a: number, b: number, titles: string) => `osio ${section}, yksiköt ${a} ja ${b} (${titles})`,
  /** Week 1: only set the course up. */
  setup: 'ota kurssi käyttöön; yksiköt alkavat ensi viikolla',
  /** After week 38: Duolingo's course is done. */
  refresh: (min: number) => `Daily Refresh, n. ${min} min päivässä`,
};

export const duolingoEn: typeof duolingoFi = {
  line: (what) => `Duolingo this week: ${what}`,
  unit: (section, unit, title) => `section ${section}, unit ${unit} (${title})`,
  units: (section, a, b, titles) => `section ${section}, units ${a} and ${b} (${titles})`,
  setup: 'set up the course; the units start next week',
  refresh: (min) => `Daily Refresh, about ${min} min a day`,
};

// Messages.duolingo (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('duolingo', duolingoFi, duolingoEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof duolingoFi> {}
}
